<script>
import { mapState } from 'vuex';

import CourseBox from '@/components/Course_B/CourseBox';
import MondialLogo from '@/components/MondialLogo';

export default {
  name: 'Courses',
  components: {
    CourseBox,
    MondialLogo,
  },
  props: {
    isDirect: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('user', [
      'courses',
    ]),
  },
};
</script>
<template>
    <div id="courses" class="pb-5">
        <div class="bg-white pt-5 pb-5" v-if="isDirect">
            <h2 class="text-center">Wybierz interesujące Cię szkolenie</h2>
        </div>
        <div class="pt-5 pb-5">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <ul>
                            <li v-for="course in courses" :key="course.id" class="p-0 mb-3">
                                <CourseBox :course="course" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <MondialLogo />
    </div>
</template>
